import React, { useState, useEffect } from 'react';
import { useCart } from '../context/CartContext';
import Button from './Button';
import QuotationForm from './QuotationForm';
import SmartCotiForm from './SmartCotiForm';
import '../styles/components/SideCart.scss';
import closeIcon from '../assets/icons/close.svg';
import basketIcon from '../assets/icons/basket.svg';
import emptyIcon from '../assets/icons/empty.svg';

const SideCart = () => {
  const {
    cartItems,
    isCartOpen,
    isSmartCoti,
    toggleCart,
    removeFromCart,
    updateQuantity,
  } = useCart();
  const [step, setStep] = useState(1);
  const [images, setImages] = useState({});

  const handleNextStep = () => setStep(2);
  const handlePreviousStep = () => setStep(1);

  useEffect(() => {
    document.body.style.overflow = isCartOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isCartOpen]);

  useEffect(() => {
    if (!isCartOpen) {
      setStep(1);
    }
  }, [isCartOpen]);

  useEffect(() => {
    if (isSmartCoti && isCartOpen) {
      setStep(2);
    }
  }, [isSmartCoti, isCartOpen]);

  useEffect(() => {
    if (cartItems.length > 0) {
      const BASE_URL = process.env.REACT_APP_S3_BASE_URL;
      const newImages = {};
      cartItems.forEach((item) => {
        // La nueva lógica usa el array 'image_files'
        if (item && Array.isArray(item.image_files) && item.image_files.length > 0) {
          newImages[item.reference] = `${BASE_URL}/thumbnails_mini/${item.image_files[0]}`;
        }
      });
      setImages(newImages);
    }
  }, [cartItems]);

  const handleBackFromForm = () => {
    if (isSmartCoti) {
      toggleCart();
    } else {
      handlePreviousStep(); 
    }
  };

  return (
    <>
      <div
        className={`SideCart__overlay ${isCartOpen ? 'active' : ''}`}
        onClick={toggleCart}
      />
      <div className={`SideCart ${isCartOpen ? 'open' : ''}`}>
        <div className="SideCart__header">
          <h2>{isSmartCoti ? 'Cotización Rápida' : 'Cesta de artículos'}</h2>
          <button
            className="SideCart__close-button"
            onClick={toggleCart}
            aria-label="Cerrar"
          >
            <img src={closeIcon} alt="Cerrar" />
          </button>
        </div>

        {step === 1 && !isSmartCoti ? (
          <>
            {cartItems.length === 0 ? (
              <div className="SideCart__empty">
                <img src={emptyIcon} alt="Vacío" />
                <h3>Cesta vacía</h3>
                <Button
                  text="Ver productos"
                  onClick={() => (window.location.href = '/categorias')}
                />
              </div>
            ) : (
              <div className="SideCart__content">
                {cartItems.map((item, index) => {
                  const thumbnailUrl = images[item.reference];
                  return (
                    <div key={index} className="SideCart__item">
                      {thumbnailUrl ? (
                        <img
                          src={thumbnailUrl}
                          alt={item.title}
                          className="SideCart__item-image"
                        />
                      ) : (
                        <div className="SideCart__item-image placeholder" />
                      )}
                      <div className="SideCart__item-details">
                        <h4>{item.title}</h4>
                        {item.variation && (
                          <p className="SideCart__item-variation">
                            Variación: {item.variation}
                          </p>
                        )}
                      </div>
                      <div className="SideCart__quantity">
                        <button
                          onClick={() =>
                            updateQuantity(item, item.quantity - 1)
                          }
                          aria-label="Disminuir"
                        >
                          −
                        </button>
                        <span>{item.quantity}</span>
                        <button
                          onClick={() =>
                            updateQuantity(item, item.quantity + 1)
                          }
                          aria-label="Aumentar"
                        >
                          +
                        </button>
                      </div>
                      <button
                        className="SideCart__remove"
                        onClick={() => removeFromCart(item)}
                        aria-label="Eliminar"
                      >
                        <img src={basketIcon} alt="Eliminar" />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
            {cartItems.length > 0 && (
              <div className="SideCart__footer">
                <Button
                  text="Cotizar artículos"
                  onClick={handleNextStep}
                  className="btn btn-primary"
                />
              </div>
            )}
          </>
        ) : (
          isSmartCoti ? (
            <SmartCotiForm onBack={handleBackFromForm} />
          ) : (
            <QuotationForm cartItems={cartItems} onBack={handleBackFromForm} />
          )
        )}
      </div>
    </>
  );
};

export default SideCart;